import { ReactNode, useState } from "react";
import Icon from "../../base/Icon";


interface ModuleSidebarProps {
    storageKey: string
    children: ReactNode
}


export default function ModuleSidebar({ storageKey, children }: ModuleSidebarProps) {

    const [collapsed, collapsedSet] = useState<boolean>(() => {
        try {
            return window.localStorage.getItem(storageKey) === "1"
        } catch {
            return false
        }
    })

    const toggle = () => {
        collapsedSet(prev => {
            const next = !prev
            try { window.localStorage.setItem(storageKey, next ? "1" : "0") } catch { }
            return next
        })
    }


    return (
        <div
            style={{
                width: collapsed ? 0 : 250,
                position: "relative",
                flexShrink: 0,
                transition: "width 0.2s ease",
                // No z-index here on purpose: keeping the sidebar out of its own
                // stacking context lets the static white panel render BELOW the
                // fixed header (z-index:108, see style.extend.css) so the
                // GeneralSearch dropdown shows on top of it. The collapse toggle
                // gets its own z-index below so it can still sit above the dark
                // aside (z-index:101).
            }}
            className={collapsed ? "" : "border-end bg-light"}>

            <button
                type="button"
                onClick={toggle}
                title={collapsed ? "Expand" : "Collapse"}
                style={{
                    position: "absolute",
                    top: 18,
                    right: collapsed ? -13 : 6,
                    width: 26,
                    height: 26,
                    padding: 0,
                    border: "1px solid #d0d3d8",
                    background: "#fff",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    // Part of the global z-index ladder (see style.extend.css):
                    // panel(no z-index) < aside(101) < button(102) < header(108)
                    //   < drawer-overlay(109) < drawer(110).
                    // 102 keeps the toggle just above the dark aside; the header
                    // (108) still sits above it, so the search dropdown and any
                    // drawer overlay correctly render on top of this button.
                    zIndex: 102,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                }}>
                <Icon icon={collapsed ? "angles-right" : "angles-left"} size={14} className="text-gray-700" />
            </button>

            {!collapsed && children}
        </div>
    )
}
